import styled from 'styled-components'

const BenefitWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-area: ${({ position }) => `benefit-${position}`};
`

export default BenefitWrapper
